import Vue from 'vue'
import Vuex from 'vuex'

import nav from './modules/nav/index'
import back from './modules/back/index'
import modal from './modules/modal/index'
import toast from './modules/toast/index'
import loading from './modules/loading/index'
import login from './modules/login/index'
import user from './modules/user/index'
import users from './modules/users/index'
import members from './modules/members/index'
import seatingStatus from './modules/seatingStatus/index'
import settings from './modules/settings/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    nav,
    back,
    modal,
    toast,
    loading,
    login,
    user,
    users,
    members,
    seatingStatus,
    settings
  }
})
